import Vue from "vue";

Vue.filter("packingSize", function(value) {
  return value + "g";
});

Vue.filter("enableDelivery", function(value) {
  return value ? "Sim" : "Não";
});

Vue.filter("yesOrNo", function(value) {
  return value ? "Sim" : "Não";
});

Vue.filter("orderStatus", function(value) {
  let result = "Aguardando aprovação";
  switch (value) {
    case "WAITING_APPROVAL":
      result = "Aguardando aprovação";
      break;
    case "APPROVED":
      result = "Aprovado";
      break;
    case "IN_PRODUCTION":
      result = "Em produção";
      break;
    case "DELIVERED":
      result = "Entregue";
      break;
    case "DELIVERING":
      result = "Saiu para entrega";
      break;
    default:
      result = "Aguardando aprovação";
      break;
  }
  return result;
});
